<template>
  <Main>
    <br />
    <sdButton type="primary" class="active" @click="$router.go(-1)">
      <sdFeatherIcons type="chevron-left" />
      {{ $t('pages.orders.detail.go-back-btn') }}
    </sdButton>
    <sdPageHeader :title="$t('pages.orders.detail.title')"> </sdPageHeader>
    <a-row :gutter="25">
      <a-col :md="12" :xs="24">
        <sdCards :title="$t('pages.orders.detail.order-info.title')">
          <ProductDetailsWrapper>
            <ul class="pdbr__list">
              <li>
                <span>{{ $t('pages.orders.detail.order-info.order-no') }}</span>
                <span>:</span>
                <span> {{ order?.order_number }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.order-state') }}</span>
                <span>:</span>
                <a-tag :color="order?.order_status ? 'green' : 'red'">
                  {{ order?.order_status ? $t('pages.orders.table-payed') : $t('pages.orders.table-unpayed') }}
                </a-tag>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.order-date') }}</span>
                <span>:</span>
                <span> {{ formatDate(order?.created_at) }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.app') }}</span>
                <span>:</span>
                <span> {{ order?.application }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.domain') }}</span>
                <span>:</span>
                <span> {{ order?.domain }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.name-surname') }}</span>
                <span>:</span>
                <span> {{ order?.customer_firstname + ' ' + order?.customer_lastname }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.order-info.email') }}</span>
                <span>:</span>
                <span> {{ order?.customer_email }}</span>
              </li>
            </ul>
          </ProductDetailsWrapper>
        </sdCards>
      </a-col>
      <a-col :md="12" :xs="24">
        <sdCards :title="$t('pages.orders.detail.bill-info.title')">
          <ProductDetailsWrapper>
            <ul class="pdbr__list">
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.name-surname') }}</span>
                <span>:</span>
                <span> {{ order?.customer_firstname + ' ' + order?.customer_lastname }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.citizenship-number') }}</span>
                <span>:</span>
                <span> {{ order?.customer_identity_number }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.country') }}</span>
                <span>:</span>
                <span> {{ order?.customer_country }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.city') }}</span>
                <span>:</span>
                <span> {{ order?.customer_city }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.address') }}</span>
                <span>:</span>
                <span> {{ order?.customer_address }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.post-code') }}</span>
                <span>:</span>
                <span> {{ order?.customer_zip_code }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.bill-info.phone') }}</span>
                <span>:</span>
                <span> {{ order?.customer_phone }}</span>
              </li>
            </ul>
          </ProductDetailsWrapper>
        </sdCards>
      </a-col>
      
    </a-row>
    <a-row :gutter="25">
      <a-col :md="12" :xs="24">
        <sdCards :title="$t('pages.orders.detail.payment-info.title')">
          <ProductDetailsWrapper>
            <ul class="pdbr__list">
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.payment-method') }}</span>
                <span>:</span>
                <span> {{ order?.payment_method == 'kredi kartı' ? $t('pages.orders.detail.payment-info.credit-card') : '' }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.price') }}</span>
                <span>:</span>
                <span> {{ formatPrice(order?.order_subtotal) }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.discount') }}</span>
                <span>:</span>
                <span> {{ formatPrice(order?.discount_total) }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.tax') }}</span>
                <span>:</span>
                <span> {{ formatPrice(order?.order_tax) }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.total-price') }}</span>
                <span>:</span>
                <span> {{ formatPrice(order?.order_total) }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.currency') }}</span>
                <span>:</span>
                <span>
                  {{ order?.order_currency == '' || order?.order_currency == 'TRY' ? 'TL' : order?.order_currency }}</span
                >
              </li>
             
              <li>
                <span>Kupon Kodu</span>
                <span>:</span>
                <span> {{ order?.coupon_code }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.fail-message') }}</span>
                <span>:</span>
                <span> {{ payment?.fail_message }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.payment-info.created-at') }}</span>
                <span>:</span>
                <span> {{ formatDate(payment?.created_at) }}</span>
              </li>
            </ul>
          </ProductDetailsWrapper>
        </sdCards>
      </a-col>
      <a-col :md="12" :xs="24">
        <sdCards :title="$t('pages.orders.detail.package-info.title')">
          <ProductDetailsWrapper>
            <ul class="pdbr__list">
              <li>
                <span>{{ $t('pages.orders.detail.package-info.name') }}</span>
                <span>:</span>
                <span> {{ package_info?.name }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.package-info.description') }}</span>
                <span>:</span>
                <span> {{ package_info?.description }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.package-info.package-duration') }}</span>
                <span>:</span>
                <span> {{ package_info?.day }} {{ $t('pages.orders.detail.package-info.day') }}</span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.package-info.start-date') }}</span>
                <span>:</span>
                <span> {{ formatDate(dates?.started_at) }} </span>
              </li>
              <li>
                <span>{{ $t('pages.orders.detail.package-info.end-date') }}</span>
                <span>:</span>
                <span> {{ formatDate(dates?.created_at) }} </span>
              </li>
            </ul>
          </ProductDetailsWrapper>
        </sdCards>
      </a-col>
    </a-row>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { ProductDetailsWrapper } from './overview/style';
import { dateToTr, priceFormat } from '@/utility/helper.js';
import { useRouter } from 'vue-router';

export default {
  name: 'DetailPage',
  components: {
    ProductDetailsWrapper,
    Main,
  },
  data() {
    return {
      order_id: this.$route.params.id,
      order: {},
      package_info: {},
      dates: {},
      payment: {}
    };
  },
  created() {
    this.getOrderDetail();
  },
  computed: {

  },
  methods: {
    formatDate(value) {
      return dateToTr(value);
    },
    formatPrice(value) {
      return priceFormat(value);
    },
    async getOrderDetail() {
      const router = useRouter();
      await this.$appAxios.post(this.$endpoints.order_detail, { id: this.order_id } ).then(response => {
      if (response.data.status === true) {
        this.order = response.data.data.order;
        this.package_info = response.data.data.package;
        this.dates = response.data.data.dates;
        this.payment = response.data.data.payment;
      } else {
        router.push('/');
      }
    });
    }
  },
};
</script>
